import script from "./PageHead.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHead.vue?vue&type=script&setup=true&lang=js"

import "./PageHead.vue?vue&type=style&index=0&id=3c0aab17&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0aab17"]])

export default __exports__